var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mb-12 mx-auto",staticStyle:{"text-align":"center"},attrs:{"src":require('./assets/logo-text-blue.png'),"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }